import React, { useState, useEffect, Suspense } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import LoadingSkeleton from "../../Component/react-loading-skeleteon/LoadingSkeleton";
import moment from "moment"
import moment1 from "moment-timezone";
import Timer from "Component/Timer/Timer";
import Currency from "Component/Currency/Currency";
import { useNavigate } from 'react-router-dom';
import { converCryptoToDollar } from "helpers/constants";

export default function CategoryCard(props) {
    const navigate = useNavigate();
  
  const categoryData = props.data;
  const [imageLoading, setImageLoading] = useState(false);
  const [time, setTime] = useState('')
  const [daysLeft, setDaysLeft] = useState(0)
  const [convertIntoCurrency, setConvertIntoCurrency]=useState("USD")
  const [timeLeft, setTimeLeft] = useState();
  useEffect(() => {
    if (categoryData.nft_id.saleType === "auction") {
      setTimeLeft(convertTimestampToDate(categoryData?.auction_time))
    }
  }, [categoryData])

  function convertTimestampToDate(timestamp) {
    // Convert timestamp to Date object
    const date = new Date(timestamp * 1000); // JavaScript timestamps are in milliseconds, so multiply by 1000

    // Get the individual date components
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Format the date string
    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoading(true);
    };

    img.src = categoryData?.nft_id?.image_id?.image?.water_mark_image_link;
  }, [
    categoryData?.nft_id?.image_id?.image?.water_mark_image_link,
    categoryData,
  ]);
  const [hasError, setHasError] = useState(false);
  function MyImageComponent({ src }) {

    const handleImageError = (event) => {
      console.error('Error loading image:', event); // Log the error event
      setHasError(true);
    };

    return hasError ? (
      <div>Error loading image. Please try again later.</div>
    ) : (
      <img src={src} loading="lazy" onError={handleImageError} alt="Images" />
    );
  }


  useEffect(() => {
    const timezone = moment.tz.guess();
    const timezoneOffset = moment.tz(timezone).utcOffset();

    if (categoryData?.sellType === "auction") {

      const localMoment = convertUtcToLocal(categoryData?.auction_time, timezoneOffset);
      const date_end = localMoment.format('YYYY-MM-DD HH:mm:ss');
      setTime(date_end);
      const today = moment().startOf('day');
      const auctionTimeMoment = moment.unix(categoryData?.auction_time).local();
      const daysLeft = auctionTimeMoment.diff(today, 'days');
      setDaysLeft(daysLeft);
    }
  }, [categoryData]);

  const [usdPrice, setUsdPrice] = useState(0);
  const [symbol,setSymbol] = useState("$");
  const setCurrnencyTobeConverted=(currency, symbol)=>{
    console.log("ajkdsklfjskldjfklajsdf", currency, symbol)
    setConvertIntoCurrency(currency)
    setSymbol(symbol)
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const calPrice = async () => {
        let amount = Number(categoryData?.nft_id?.price)
        let symbol = "MATIC";
        let data = await converCryptoToDollar(amount, symbol, convertIntoCurrency);
        setUsdPrice((pre) => ({
          ...pre,
          data,
        }));
      };
      calPrice({ price: Number(categoryData?.nft_id?.price)});
    }, 300);
    return () => clearTimeout(delayDebounceFn);

  }, [categoryData, convertIntoCurrency]);
  return (
  <>
    {/* <Link
      className="text-decoration-none"
      to={
        categoryData?.sellType === "auction"
          ? `/liveAuctionNft/${props?.data?._id}`
          : `/nftsale/${props?.data?._id}`
      }
    > */}
      {imageLoading === true ? (
        <div className="artItemBoxNew">
          <div className="imgBox" onClick={() => navigate(
          categoryData?.sellType === "auction"
            ? `/liveAuctionNft/${props?.data?._id}`
            : `/nftsale/${props?.data?._id}`
        )}
        style={{ cursor: 'pointer' }}>
            <div class="artistNameBox">
              <div className="d-flex align-items-center gap-2">
                <Suspense>


                  <img
                    src={categoryData?.owner_id?.profileImage?.link}
                    alt=""
                  />
                </Suspense>
                {" "}


                <h5>{categoryData?.owner_id?.name?.length > 8 ? categoryData?.owner_id?.name?.slice(0, 8) + "..." : categoryData?.owner_id?.name}</h5>
              </div>

            </div>
            
            <div className="imginn">
              {/* <img
                className="img-fluid"
                src={
                  categoryData?.nft_id?.image_id?.image?.water_mark_image_link
                    ? categoryData?.nft_id?.image_id?.image
                      ?.water_mark_image_link
                    : categoryData?.nft_id?.image_id?.image?.link
                }
                alt=""
              /> */}
              <MyImageComponent src={categoryData?.nft_id?.image_id?.image?.water_mark_image_link
                ? categoryData?.nft_id?.image_id?.image
                  ?.water_mark_image_link
                : categoryData?.nft_id?.image_id?.image?.link} />
            </div>
            {categoryData?.nft_id?.saleType === "auction" && (
              <button className="priceTag">
                Current Bid - {categoryData?.current_price}{" "}
                <img
                  src="/images/svg/maticIcon.svg"
                  width={25}
                  height={25}
                  alt="Matic"
                />{" "}
              </button>
            )}
          </div>
          
          <div className="contBox">
            <div className="arthead">
              <h2 className="productName" title={categoryData?.nft_id?.name}>
                {categoryData?.nft_id?.name}{" "}
              </h2>
              {/* {categoryData?.nft_id?.saleType === 'fixed' &&
                <h2 className="productPrice d-flex align-items-center gap-2">
                  {categoryData?.nft_id?.price}{" "}
                  <img
                    src="/images/svg/maticIcon.svg"
                    width={18}
                    height={18}
                    alt="Matic"
                  />
                </h2>} */}
            </div>
            {/* <p>{categoryData.description}</p> */}
            {categoryData?.nft_id?.saleType === "auction" ? (
              <div className="auctionPrice mt-2">
                <div className="priceBoxAuc align-items-baseline mb-3">
                  <h2>Opening Amount</h2>
                  <div>
                  <h3>
                    {categoryData?.nft_id?.price}{" "}
                    <img
                      src="/images/svg/maticIcon.svg"
                      width={18}
                      height={18}
                      alt="Matic"
                    />
                  </h3>
                  
                  </div>
                </div>
                <div className="priceBoxAuc align-items-baseline mb-3">
                <div className="contBox">
                    <div className="artPriceBox">
                  <div class="artRate">
                    <h5>  {symbol+" "+ Number(usdPrice?.data).toFixed(5)} </h5>
                    <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted}  />
                    </div>
                    </div>
                  </div>
                  </div>
                <div className="priceBoxAuc artPriceBox">
                  <div className="endsaletxt">
                    <h2>End In</h2>
                    <h3>
                      {daysLeft} {daysLeft > 1 ? "Days" : "Day"} <Timer date={time} />
                    </h3>
                  </div>
                  <ul>
                    <li>
                      <img
                        src="/images/svg/eyeNew.svg"
                        width="25"
                        height="25"
                        alt=""
                      />{" "}
                      <h5>{categoryData?.view_count}</h5>
                    </li>
                    <li>
                      <img
                        src="/images/svg/likeNew.svg"
                        width="25"
                        height="25"
                        alt=""
                      />
                      <h5>{categoryData?.like_count}</h5>
                    </li>
                  </ul>
                </div>

              </div>
            ) : (
              <>
              <div class="artPriceBox align-items-start mt-2">
                {categoryData?.nft_id?.saleType === "fixed" && (
                  <div>
                  <div class="artRate d-block text-start">
                    {/* <h4> {Number(categoryData?.nft_id?.price).toFixed(5)} </h4>
                    <img
                      src="/images/svg/maticIcon.svg"
                      width="18"
                      height="18"
                      alt=""
                    /> */}
                    <h4>{symbol+" "+ Number(usdPrice?.data).toFixed(6)}   </h4>
                    <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />
                  </div>
                   
                  </div>
                )}
                <ul>
                  <li>
                    <img
                      src="/images/svg/eyeNew.svg"
                      width="25"
                      height="25"
                      alt=""
                    />{" "}
                    <h5>{categoryData?.view_count}</h5>
                  </li>
                  <li>
                    <img
                      src="/images/svg/likeNew.svg"
                      width="25"
                      height="25"
                      alt=""
                    />
                    <h5>{categoryData?.like_count}</h5>
                  </li>
                </ul>
              </div>
              {/* <div class="artPriceBox align-items-baseline mt-2">
              <div class="artRate">
                      <h5>{symbol+" "+ Number(usdPrice?.data).toFixed(6)}   </h5>
                      <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />
                      
                    </div>
                    </div> */}
                    </>
            )}

            <button className="exploreBtn" onClick={() => navigate(
          categoryData?.sellType === "auction"
            ? `/liveAuctionNft/${props?.data?._id}`
            : `/nftsale/${props?.data?._id}`
        )}
        style={{ cursor: 'pointer' }}>Explore Now</button>
          </div>
        </div>
      ) : (
        <div className="artItemBoxNew">
          <div className="imgBox" style={{ aspectRatio: 1 / 1 }}>
            <LoadingSkeleton count={1} style={{ height: "100%" }} />
          </div>
        </div>
      )}
    {/* </Link> */}
    </>
  );
}
const convertUtcToLocal = (utcTimestamp, timezoneOffset) => {
  const utcMoment = moment1.unix(utcTimestamp);
  const localMoment = utcMoment.utcOffset(timezoneOffset);
  return localMoment;
}
